import type { RouterOutputs } from "@repo/api";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { DeviceContext } from "~/hooks/use-device";
import { api } from "~/lib/api";
import { useLoadingStore } from "~/stores/use-loading-store";

interface DeviceProviderProps {
  children: ReactNode;
}

export type Device = RouterOutputs["device"]["getAll"][number];

export function DeviceProvider({ children }: DeviceProviderProps) {
  const { data: devices, isFetching: isDevicesLoading } =
    api.device.getAll.useQuery(undefined, {
      initialData: [],
    });

  const { setLoadingStage } = useLoadingStore(
    useShallow((state) => ({
      setLoadingStage: state.setCurrentLoadingStage,
    })),
  );

  useEffect(() => {
    if (isDevicesLoading) {
      setLoadingStage("labels");
    } else {
      setLoadingStage(undefined);
    }
  }, [isDevicesLoading, setLoadingStage]);

  const context = {
    devices,
  };

  return (
    <DeviceContext.Provider value={context}>{children}</DeviceContext.Provider>
  );
}
